<div class="foa-holder">
    <foa-header></foa-header>
    <router-outlet>
    </router-outlet>
    <div class="filler"></div>
    <foa-footer></foa-footer>
</div>
